import React, { useEffect, useState } from "react";
import * as httpClient from "../../util/httpClient";
import { useDispatch, useSelector } from "react-redux";
import * as LoginActions from "../../store/loginService/actions";
import { useForm } from "react-hook-form";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { Notification } from "../common/Notification";
import { DialogComponent } from "../common/DialogComponent";
import DashboardSecurityQuestionDialog from "../Dialogs/DashboardSecurityQuestionDialog";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { GET_ACCOUNT_INFORMATION_LOADER } from "../../store/myAccount/types";
import { useTranslation } from "react-i18next";

const ChangePassword = (props: any) => {
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const { register, handleSubmit, errors, watch, setError, getValues } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const [state, setState] = useState({
        firstInteractionDone: false,
    });
    const [isPwdLoading, setIsPwdLoading] = useState(false);
    const [showSecurityQuestionDialog, setShowSecurityQuestionDialog] = useState(false);
    const [rememberThisDevice, setRememberThisDevice] = useState(false);
    const unifiedAccInfo = useSelector((state: ApplicationState) =>
        state && state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null
    );

    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isIDFPartner: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isIdfPartner
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );

    const accountInfo = useSelector((state: ApplicationState) => {
        if (state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo && state.myAccountServiceState._unifiedAccountInfo._passwordSecurity) {
            return {
                lastPasswordChangeDate:
                    state.myAccountServiceState._unifiedAccountInfo._passwordSecurity &&
                    state.myAccountServiceState._unifiedAccountInfo._passwordSecurity.lastPasswordChangeDate,
                isSSOUser: state.myAccountServiceState._unifiedAccountInfo.isSSOUser ? state.myAccountServiceState._unifiedAccountInfo.isSSOUser : false,
            };
        } else {
            return {
                lastPasswordChangeDate: "",
            };
        }
    });

    const partnerPhone = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.phoneNumber) ||
            ""
    );

    const getQuestionInfo = useSelector((state: ApplicationState) => {
        if (state.myAccountServiceState && state.myAccountServiceState.securityQueData) {
            return {
                securityQueData: state.myAccountServiceState.securityQueData,
            };
        } else {
            return {
                securityQueData: [],
            };
        }
    });

    let userData = useSelector((state: ApplicationState) => {
        let data: any = {
            email: "",
            isIDFUser: false,
            isSuccess: true,
            securityQuestionsCount: 3,
            portalName: "",
            isLanguageSupport: "true"
        };
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig != null) {
            data.portalName = state.configurationState.configuration.partnerConfig.partnerProvider;
        }

        if (unifiedAccInfo && unifiedAccInfo.email) {
            data.email = unifiedAccInfo.email;
        }
        if (state.csidUserStatusState && state.csidUserStatusState.csidUserStatus) {
            data.isIDFUser = state.csidUserStatusState.csidUserStatus.isIDFUser;
        }
        return data;
    });

    const validation = {
        minLengthCharacter: (val: any) => /^.{12,}$/.test(val),
        containsCapitalLetter: (val: any) => /.*[A-Z].*/.test(val),
        containsSpecialLetter: (val: any) => /[*@!#%&()^~{}$\-_+=\[\]\|;:"'<,>\.\?]+/.test(val),
        containsSmallLetter: (val: any) => /.*[a-z].*/.test(val),
        containsNumber: (val: any) => /\d/.test(val),
    };

    const validationMessage: Record<string, string> = {
        minLengthCharacter: tLang("changePassword.validation.minLengthCharacter"),
        containsCapitalLetter: tLang("changePassword.validation.containsCapitalLetter"),
        containsSmallLetter: tLang("changePassword.validation.containsSmallLetter"),
        containsNumber: tLang("changePassword.validation.containsNumber"),
        containsSpecialLetter: tLang("changePassword.validation.containsSpecialLetter"),
    };

    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const getAccountInformation = () => {
        httpClient
            .sendRequest("GET", "api/accountInfo/getAccountInformation")
            .then((data) => {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
                if (data && data.hasError === false) {
                    if (data && data._unifiedAccountInfo && data._unifiedAccountInfo.isSSOUser === false) {
                        setIsPwdLoading(false);
                        dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: true });
                        httpClient
                            .sendRequest("POST", "api/security-question/get-security-questions", userData)
                            .then((res) => {
                                if (res && res.hasError === false) {
                                    dispatch({ type: "GET_SECURITY_QUESTIONS", securityQueData: res });
                                    if (res && res.selectedSecurityQuestion === null) {
                                        props.history.push({
                                            pathname: "/dashboard",
                                        });
                                    }
                                }
                            })
                            .catch(function (error) { });
                    }
                    dispatch({
                        type: "GET_ACCOUNT_INFORMATION",
                        _unifiedAccountInfo: data._unifiedAccountInfo,
                    });
                }
            })
            .catch(function (error) {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
            });
    };

    const onSubmit = (data: any) => {
        if (getValues("confirmPassword") !== watch("newPassword")) {
            setError("confirmPassword", {
                type: "validate",
            });
        } else {
            setIsPwdLoading(true);
            const url =  "web/password/SSOChangePassword";
            httpClient
                .sendRequest("POST", url, data)
                .then((res) => {
                    if (!res.isSuccess) {
                        setIsPwdLoading(false);
                        setError("currentPassword", {
                            type: "isPasswordWrong",
                        });
                    } else {
                        getAccountInformation();                       
                    }
                    
                })
                .catch((err) => {
                    setIsPwdLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 0,
                    });
                });
        }
    };

    const login = (email: string, password: string, addSecurityQuestion: boolean) => {
        const requestBody = {
            EmailAddress: email,
            Password: password,
            CaptchaValue: "",
        };

        setIsPwdLoading(true);

        httpClient
            .sendRequest("POST", "web/login/UserLogin", requestBody)
            .then((data) => {
                if (data.isValidUser) {
                    data.EmailAddress = email;
                    const request = {
                        isSaveCookie: rememberThisDevice,
                    };
                    httpClient.sendRequest("POST", "web/login/RememberThisDevice", request).then((data1) => {
                        if (data1.isSuccess) {
                            dispatch(ConfigurationActions.actionCreators.requestCountryList(isIDFPartner, partnerID));
                            dispatch(LoginActions.actionCreators.authenticateForgotPasswordFlow(data, props.history, addSecurityQuestion));
                        } else {
                            setIsPwdLoading(false);
                        }
                    });
                } else {
                    setIsPwdLoading(false);
                }
            })
            .catch(function (error) {
                setIsPwdLoading(false);
            });
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                {tLang("manageAccount.myAccount.manageAccountPassword.label.password")}
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className={isPwdLoading ? "loading box box-has-shadow box-xs offset-padding" : "box box-has-shadow box-xs offset-padding"}>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("changePassword.label.password")}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <form id="form-change-password" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="current-password-label">{tLang("changePassword.label.currentPassword")}</label>
                                            </div>
                                            <div className="form-input">                                               
                                                <input
                                                    type="password"
                                                    id="current-password-label"
                                                    className={errors.currentPassword ? "status-error inputbox" : "inputbox"}
                                                    ref={register({
                                                        required: true,
                                                        
                                                    })}
                                                    name="currentPassword"
                                                />
                                                {errors.currentPassword && errors.currentPassword.type === "required" && (
                                                    <span className="form-error">
                                                        <p>{tLang("changePassword.validation.currentPassword.required")}</p>
                                                    </span>
                                                )}
                                                {errors.currentPassword && errors.currentPassword.type === "isPasswordWrong" && (
                                                    <span className="form-error">
                                                        <p>
                                                            {tLang("changePassword.validation.currentPassword.passwordWrong")} {partnerPhone}
                                                        </p>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="password-label">{tLang("changePassword.label.newPassword")}</label>
                                            </div>
                                            <div className="form-input">
                                                <input
                                                    type="password"
                                                    autoComplete="off"
                                                    className={errors.newPassword ? "status-error inputbox" : "inputbox"}
                                                    id="password-label"
                                                    onBlur={(e) => setState({ ...state, firstInteractionDone: true })}
                                                    name="newPassword"
                                                    ref={register({ validate: validation })}
                                                />
                                                {Object.keys(validationMessage).map((key, value) => {
                                                    let validationResultClass;

                                                    if (!state.firstInteractionDone && errors && !errors.newPassword) {
                                                        validationResultClass = "validation-default";
                                                    }

                                                    if (state.firstInteractionDone && errors && !errors.newPassword) {
                                                        validationResultClass = "validation-true";
                                                    }
                                                    if (state.firstInteractionDone && errors && errors.newPassword && errors.newPassword.types) {
                                                        validationResultClass = errors.newPassword.types[key] ? "validation-false" : "validation-true";
                                                    }
                                                    if (!state.firstInteractionDone && errors && errors.newPassword && errors.newPassword.types) {
                                                        validationResultClass = errors.newPassword.types[key] ? "validation-false" : "validation-true";
                                                    }
                                                    return (
                                                        <span className={validationResultClass}>
                                                            <p key={key}>{validationMessage[key]}</p>
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="confirm-password-label">{tLang("changePassword.label.confirmPassword")}</label>
                                            </div>
                                            <div className="form-input">
                                                <input
                                                    type="password"
                                                    id="confirm-password-label"
                                                    className={errors.confirmPassword ? "status-error inputbox" : "inputbox"}
                                                    ref={register({
                                                        required: true,
                                                    })}
                                                    name="confirmPassword"
                                                    id="confirm-password-label"
                                                    onBlur={() => {
                                                        if (getValues("confirmPassword") !== "" && getValues("confirmPassword") !== watch("newPassword")) {
                                                            setError("confirmPassword", {
                                                                type: "validate",
                                                            });
                                                        }
                                                    }}
                                                />
                                                {errors.confirmPassword && errors.confirmPassword.type === "validate" && (
                                                    <span className="form-error">
                                                        <p>{tLang("changePassword.validation.confirmPassword.misMatch")}</p>
                                                    </span>
                                                )}
                                                {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                                                    <span className="form-error">
                                                        <p>{tLang("changePassword.validation.confirmPassword.required")}</p>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-input">
                                                <label className="form-checkbox-label" htmlFor="remember_me">
                                                    <input
                                                        type="checkbox"
                                                        name="isChecked"
                                                        id="remember_me"
                                                        onChange={() => setRememberThisDevice(!rememberThisDevice)}
                                                        checked={rememberThisDevice}
                                                    />
                                                    <span className="form-checkbox-label-text">{tLang("resetPassword.rememberDevice")}</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="margin-bottom-s"></div>

                                        <div className="form-row">
                                            <button type="submit" className="btn-default btn-primary">
                                                <span className="btn-text">{tLang("resetPassword.submitBtn")}</span>
                                            </button>
                                        </div>                                  
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ChangePassword;
